'use strict';

require("core-js/modules/es6.array.map");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.set");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Option = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _dec, _class, _dec2, _class2, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

var _util = require('../util');

var _constants = require('../constants');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = function styles(theme) {
  return {
    root: {
      width: '100%',
      '& > div': {
        width: '100%'
      }
    },
    options: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      fontSize: '2rem',
      padding: [[20, 20, 10]],
      width: '100%'
    },
    wrapper: {
      alignItems: 'center',
      border: theme.cardBorder,
      borderRadius: 4,
      cursor: 'pointer',
      display: 'flex',
      marginBottom: 15,
      marginRight: 10,
      padding: [[5, 3, 5, 10]],
      position: 'relative',
      textAlign: 'left',
      transition: [['background', '0.2s', 'ease']],
      width: '100%',
      '&:hover': {
        background: theme.bgMeta
      }
    },
    wrapperSelected: {
      background: theme.bgMeta
    },
    checkbox: {
      flex: '0 0 20px',
      height: 20,
      marginRight: 20,
      width: 20,
      // Try setting a default font size in case iOS Safari tries to zoom
      // for whatever reason. Also see https://support.prodi.gy/t/2608
      fontSize: 16
    },
    content: {
      flex: '100%',
      maxWidth: '100%'
    },
    key: {
      background: theme.bgCard,
      border: theme.cardBorder,
      borderRadius: 4,
      display: 'block',
      fontSize: 13,
      padding: [[1, 7]],
      position: 'absolute',
      right: -8,
      textAlign: 'center',
      top: '23%'
    },
    '@supports (top: calc(50% - 1rem))': {
      key: {
        top: 'calc(50% - 10px)'
      }
    },
    '@media(min-width: 52em)': {
      wrapperCols: {
        padding: 5,
        flex: '0 1 calc(50% - 10px)',
        flexDirection: 'column-reverse',
        maxWidth: 'calc(50% - 10px)'
      },
      wrapperColsWide: {
        maxWidth: 'calc(33.33% - 10px)',
        flex: '0 0 calc(33.33% - 20px)'
      },
      checkboxCols: {
        margin: [[10, 0, 0, 0]]
      },
      keyCols: {
        right: 10,
        top: -10
      }
    }
  };
};

var Option = exports.Option = (_dec = (0, _util.withStyles)(styles), _dec(_class = function (_React$Component) {
  _inherits(Option, _React$Component);

  function Option() {
    _classCallCheck(this, Option);

    return _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).apply(this, arguments));
  }

  _createClass(Option, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          id = _props.id,
          _props$name = _props.name,
          name = _props$name === undefined ? 'choice' : _props$name,
          style = _props.style,
          isSelected = _props.isSelected,
          columns = _props.columns,
          onClick = _props.onClick,
          type = _props.type,
          keyNum = _props.keyNum,
          showKey = _props.showKey,
          classes = _props.classes,
          className = _props.className,
          children = _props.children;
      var checkboxProps = {
        name: name,
        type: type,
        id: id,
        checked: isSelected
      };
      var wrapperClassNames = (0, _classnames2["default"])(classes.wrapper, className, (_classNames = {}, _defineProperty(_classNames, classes.wrapperSelected, isSelected), _defineProperty(_classNames, classes.wrapperCols, columns), _defineProperty(_classNames, classes.wrapperColsWide, columns == 3), _classNames));
      var checkboxClassNames = (0, _classnames2["default"])(classes.checkbox, _defineProperty({}, classes.checkboxCols, columns));
      var keyClassNames = (0, _classnames2["default"])(classes.key, _defineProperty({}, classes.keyCols, columns));
      return _react2["default"].createElement('div', {
        className: wrapperClassNames,
        onClick: onClick,
        style: style
      }, _react2["default"].createElement('input', _extends({
        className: checkboxClassNames
      }, checkboxProps)), _react2["default"].createElement('div', {
        className: classes.content
      }, children), showKey && _react2["default"].createElement('span', {
        className: keyClassNames
      }, keyNum));
    }
  }]);

  return Option;
}(_react2["default"].Component)) || _class);
var Choice = (_dec2 = (0, _util.withStyles)(styles), _dec2(_class2 = (_temp2 = _class3 = function (_React$Component2) {
  _inherits(Choice, _React$Component2);

  function Choice() {
    var _ref;

    var _temp, _this2, _ret;

    _classCallCheck(this, Choice);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = Choice.__proto__ || Object.getPrototypeOf(Choice)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
      selected: []
    }, _this2.componentDidMount = function () {
      _this2.updateTaskConfig();

      if (_this2.props.content.accept) {
        _this2.setState({
          selected: _this2.props.content.accept
        });
      }
    }, _this2.componentWillReceiveProps = function (_ref2) {
      var content = _ref2.content;
      var accept = content.accept;

      _this2.setState({
        selected: accept || []
      });

      if (!accept) {
        // Make sure all examples have an "accept" key, even if the user
        // doesn't select anything
        _this2.props.update({
          accept: []
        });
      }
    }, _this2.componentDidUpdate = function (prev) {
      var content = _this2.props.content;

      if (prev.content && prev.content[_constants.TASK_ID] != content[_constants.TASK_ID]) {
        _this2.updateTaskConfig();
      }
    }, _this2.updateTaskConfig = function () {
      // Preserve choice style on task
      var taskConfig = _this2.props.content.config || {};
      var choiceStyle = _this2.props.config.choiceStyle;

      _this2.props.update({
        config: _extends({}, taskConfig, {
          choice_style: choiceStyle
        })
      });
    }, _this2.getChoices = function (id) {
      var accepted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var isSingle = _this2.props.config.choiceStyle == 'single';
      var autoAccept = _this2.props.config.choiceAutoAccept;

      if (isSingle) {
        if (!autoAccept) {
          return accepted.toString() == [id].toString() ? [] : [id];
        }

        return accepted.includes(id) ? accepted : [id];
      }

      if (accepted.includes(id)) {
        return accepted.filter(function (i) {
          return i != id;
        });
      }

      return [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(accepted), [id]))));
    }, _this2.updateChoice = function (id) {
      var accept = _this2.getChoices(id, _this2.state.selected);

      _this2.setState({
        selected: accept
      });

      _this2.props.update({
        accept: accept
      });

      if (_this2.props.config.choiceAutoAccept) {
        setTimeout(function () {
          return _this2.props.answer('accept');
        }, 250);
      }
    }, _this2.handleChoice = function (ev) {
      ev.preventDefault();
      var key = (0, _util.getNumberKey)(ev);

      if (_this2.props.content.options && _this2.props.content.options[key - 1]) {
        _this2.updateChoice(_this2.props.content.options[key - 1].id);
      }
    }, _this2.isSelected = function (id) {
      return _this2.state.selected.includes(id);
    }, _this2.getInputCard = function (task) {
      var _this2$props = _this2.props,
          content = _this2$props.content,
          restProps = _objectWithoutProperties(_this2$props, ['content']);

      var input = _this2.props.getInterfaceComp(_extends({}, task, {
        options: false
      }), restProps);

      if (input == 'text' && !task.text) {
        return null;
      }

      return input;
    }, _this2.getColumns = function (options) {
      var view = (0, _util.findInterface)(options[0]);

      if (view != 'image') {
        return 0;
      }

      if (options.spans) {
        return 1;
      }

      if (options.length >= 3 && options.length % 3 == 0) {
        return 3;
      }

      return 1;
    }, _this2.handleShortcuts = function (action, ev) {
      var labelKeymap = _this2.props.config.labelKeymap;
      var keymapByKey = (0, _util.invertObject)(labelKeymap);
      var options = _this2.props.content.options;

      switch (action) {
        case 'choice':
          ev.preventDefault();

          if (options && options.length) {
            var fromKeymap = keymapByKey[event.key];
            var num = fromKeymap ? parseInt(fromKeymap) : (0, _util.getNumberKey)(ev) - 1;

            if (num < options.length && fromKeymap || typeof labelKeymap[String(num)] == 'undefined') {
              _this2.updateChoice(options[num].id);
            }
          }

          break;
      }
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(Choice, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          content = _props2.content,
          config = _props2.config,
          getInterfaceComp = _props2.getInterfaceComp,
          classes = _props2.classes;
      var options = content.options || [];
      var columns = this.getColumns(options);
      var inputCard = this.getInputCard(content);
      var ChoiceOption = this.props.ChoiceOption || Option; // Generate a random "name" value for the options to prevent clash
      // (e.g. if more than one choice interface is used in blocks)

      var name = (0, _v2["default"])();
      var shortcutProps = {
        name: 'CARD',
        handler: this.handleShortcuts,
        targetNodeSelector: 'body',
        global: true
      };
      return _react2["default"].createElement(_react.Fragment, null, inputCard, _react2["default"].createElement('div', {
        className: classes.root
      }, _react2["default"].createElement(_util.ShortcutsWrapper, _extends({
        ctx: this.context.shortcuts
      }, shortcutProps), _react2["default"].createElement('div', {
        className: classes.options
      }, options.map(function (option, i) {
        var type = config.choiceStyle == 'multiple' ? 'checkbox' : 'radio';
        var labelKey = config.labelKeymap[String(i)];
        var hasLabelKey = typeof labelKey !== 'undefined';
        var key = hasLabelKey ? labelKey : i + 1;
        return _react2["default"].createElement(ChoiceOption, {
          key: i,
          id: option.id,
          name: name,
          style: option.style,
          meta: option.meta,
          isSelected: _this3.isSelected(option.id),
          columns: columns,
          onClick: function onClick(ev) {
            return _this3.updateChoice(option.id);
          },
          type: type,
          keyNum: key,
          showKey: hasLabelKey || options.length <= 30
        }, getInterfaceComp(option, {
          config: config,
          nowrap: true
        }));
      })))));
    }
  }]);

  return Choice;
}(_react2["default"].Component), _class3.id = 'choice', _class3.propTypes = {
  content: _propTypes2["default"].object.isRequired,
  config: _propTypes2["default"].object.isRequired,
  update: _propTypes2["default"].func.isRequired,
  getInterfaceComp: _propTypes2["default"].func
}, _class3.contextTypes = {
  shortcuts: _propTypes2["default"].object
}, _temp2)) || _class2);
exports["default"] = Choice;